import { defineMessages } from 'react-intl';

export default defineMessages({
  desOfOpeOrPurOfOrg: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Description of Operations or Purpose of Organization',
    defaultMessage: 'Description of Operations or Purpose of Organization',
  },
  typOfOrg3: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Type of Organization',
    defaultMessage: 'Type of Organization',
  },
  isOrgInc4: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Is Organization Incorporated?',
    defaultMessage: 'Is Organization Incorporated?',
  },
  ifYesIncUndTheLawOf5: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.If Yes, Incorporated under the laws of which Province',
    defaultMessage: 'If Yes, Incorporated under the laws of which Province',
  },
  datInc6: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Date Incorporated',
    defaultMessage: 'Date Incorporated',
  },
  web7: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Website',
    defaultMessage: 'Website',
  },
  numOfShaHolMorTha258: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Number of shareholders holding more than 25% of shares',
    defaultMessage: 'Number of shareholders holding more than 25% of shares',
  },
  actOutOfCan9: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Activities outside of Canada',
    defaultMessage: 'Activities outside of Canada',
  },
  ifYesDes10: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.If Yes, Describe',
    defaultMessage: 'If Yes, Describe',
  },
  doYouConAnyOpeAwaFro11: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Do you conduct any operations away from premises',
    defaultMessage: 'Do you conduct any operations away from premises',
  },
  ifYesDes12: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.If Yes, Describe',
    defaultMessage: 'If Yes, Describe',
  },
  theComOrOrgHasPubRep16: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.The Company or Organization has published reports and accounts in the two latest consecutive financial years showing unqualified reports by independent auditors or accountants, net profit and positive net worth, no litigation, disputes or contingent or extraordinary liabilities and can pay any and all of its debts as they fall due.',
    defaultMessage:
      'The Company or Organization has published reports and accounts in the two latest consecutive financial years showing unqualified reports by independent auditors or accountants, net profit and positive net worth, no litigation, disputes or contingent or extraordinary liabilities and can pay any and all of its debts as they fall due.',
  },
  ifNoPleProDet17: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.If No, please provide details',
    defaultMessage: 'If No, please provide details',
  },
  areTheAnyPlaOrIntFor18: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Are there any plans or intentions for the Organization or any of its subsidiaries to file or register or to make a listing offering or issuance of stock, shares, debentures, bonds, commercial paper or other debt or equity instruments or any other securities? Or merge with, or be taken over by any other entity or make any acquisitions or disposal or to terminate or wind-up or reorganize or for there to be any material change in the ownership of the Company (including, but not limited to a management buy-out)?',
    defaultMessage:
      'Are there any plans or intentions for the Organization or any of its subsidiaries to file or register or to make a listing offering or issuance of stock, shares, debentures, bonds, commercial paper or other debt or equity instruments or any other securities? Or merge with, or be taken over by any other entity or make any acquisitions or disposal or to terminate or wind-up or reorganize or for there to be any material change in the ownership of the Company (including, but not limited to a management buy-out)?',
  },
  ifYesPleProFulDet19: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.If yes, please provide full details',
    defaultMessage: 'If yes, please provide full details',
  },
  StaffDetailsTitle: {
    id: 'quoteandbind.PPLProLinedirectives.templates.ProductCoverageSelection.Staff Details',
    defaultMessage: 'Staff Details',
  },
  numOfDirOff21: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Number of Directors / Officers',
    defaultMessage: 'Number of Directors / Officers',
  },
  numOfEmpUni22: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Number of Employees - Unionized',
    defaultMessage: 'Number of Employees - Unionized',
  },
  numOfEmpNon23: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Number of Employees - Non-Unionized',
    defaultMessage: 'Number of Employees - Non-Unionized',
  },
  totNumOfEmp24: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Total - Number of Employees',
    defaultMessage: 'Total - Number of Employees',
  },
  noOfSha25: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.No. of Shareholders',
    defaultMessage: 'No. of Shareholders',
  },
  noOfMem26: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.No. of Members',
    defaultMessage: 'No. of Members',
  },
  noOfVol27: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.No. of Volunteers',
    defaultMessage: 'No. of Volunteers',
  },
  BusinessOperationsAccordionDetails: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperations.Business Operations',
    defaultMessage: 'Business Operations',
  },
  doeTheOrgEngInAnyOf13: {
    id: 'quoteandbind.PPLProLinedirectives.templates.BusinessOperation.Does the organization engage in any of the following classes',
    defaultMessage: "Does the organization engage in any of the following classes: Any risk with A U.S. location, any risk with U.S. domiciled employees, U.S. subsidiaries will be excluded / Armoured Vehicle Services / Broadcasting / Cannabis / Commercial Aviation / Company shares traded on a public exchange / Construction Industry / Daycare facilities / Exploration, Mining, O&G/ Financial Institutions, Banks, Credit Unions, Investment Management, Hedge Funds / Gambling / Insurance Company / Jewellery Merchants / Labour Unions / Law Firms / Lending Institutions / Mortgage Company and Lenders / Pawn Shops / Pharmaceuticals / Political Risks including Political Activist groups / Professional Sports Team / Publicly Trades Companies / Real Estate Sales and Investments / Senior Care homes / Stamp Merchants / Stockbrokers / Telecommunications / Tobacco / Unincorporated companies\\organizations / Utilities / Venture Capital Company"
  }
});
